export { default as default } from './Joc';
